import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { NAMESPACE, resources as res } from './index'

export const defaultNS = NAMESPACE.RESOURCES
export const resources = res

i18next
  // this is the same as in their docs
  // the error bellow is their problem
  // @ts-ignore
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources,
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      defaultVariables: {
        carersProfileVariable: 'carer',
        carePlansVariable: 'care plans'
      }
    },
    // get the namespaces from the NAMESPACE object
    ns: Object.keys(NAMESPACE).map(
      (key) => NAMESPACE[key as keyof typeof NAMESPACE]
    ),
    defaultNS: NAMESPACE.RESOURCES
  })
